import React from 'react';
import { UsersIcon, FileTextIcon, TruckIcon, ClockIcon } from 'lucide-react';
import { StatsCard } from '../components/StatsCard';
import { StatusBadge } from '../components/StatusBadge';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
export function Dashboard() {
  const permitData = [{
    month: 'Oct',
    permits: 520
  }, {
    month: 'Nov',
    permits: 680
  }, {
    month: 'Dec',
    permits: 590
  }, {
    month: 'Jan',
    permits: 720
  }, {
    month: 'Feb',
    permits: 650
  }, {
    month: 'Mar',
    permits: 780
  }];
  const professionData = [{
    name: 'Jele (Fisher)',
    value: 45,
    color: '#1B5E20'
  }, {
    name: 'Moual (Honey)',
    value: 30,
    color: '#2E7D32'
  }, {
    name: 'Bawali (Wood)',
    value: 25,
    color: '#66BB6A'
  }];
  const recentActivity = [{
    time: '10:45 AM',
    user: 'Rahim Uddin',
    action: 'Applied for Fishing Permit',
    status: 'pending' as const
  }, {
    time: '10:30 AM',
    user: 'Station Officer - Katka',
    action: 'Approved Beneficiary: Karim Sheikh',
    status: 'approved' as const
  }, {
    time: '10:15 AM',
    user: 'Abdul Hakim',
    action: 'Started Trip to Chandpai Range',
    status: 'active' as const
  }, {
    time: '09:50 AM',
    user: 'Field Officer - Dhangmari',
    action: 'Registered New Vessel',
    status: 'approved' as const
  }, {
    time: '09:30 AM',
    user: 'Fatema Begum',
    action: 'Completed Trip',
    status: 'approved' as const
  }];
  const pendingApprovals = [{
    id: 'BEN-2024-1234',
    name: 'Jamal Hossain',
    type: 'Beneficiary Registration',
    date: '2024-03-30'
  }, {
    id: 'PER-2024-5678',
    name: 'Nur Islam',
    type: 'Fishing Permit',
    date: '2024-03-30'
  }, {
    id: 'VES-2024-9012',
    name: 'Habib Mollah',
    type: 'Vessel Registration',
    date: '2024-03-29'
  }];
  return <div className="space-y-6" data-id="element-833" data-mp="2haqap5bq5yvy">
      <div data-id="element-834" data-mp="2h9on61divjxc">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-835" data-mp="2haglhjyi7vrb">Dashboard</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-836" data-mp="2cbn5nkvqvsnz">
          Overview of Sundarban Permit Management System
        </p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-837" data-mp="1oo5jq5z5vosx">
        <StatsCard icon={<UsersIcon size={24} data-id="element-839" data-mp="1xn0qpka152xa" />} label="Total Beneficiaries" value={28450} trend={{
        value: 12,
        isPositive: true
      }} data-id="element-838" data-mp="1jp2cqfzmf8ib" />
        <StatsCard icon={<FileTextIcon size={24} data-id="element-841" data-mp="391w7bbs8legh" />} label="Active Permits" value={3240} trend={{
        value: 8,
        isPositive: true
      }} data-id="element-840" data-mp="1tnrywkyjvf4d" />
        <StatsCard icon={<TruckIcon size={24} data-id="element-843" data-mp="3cjtvrcstdg3o" />} label="Trips Today" value={156} trend={{
        value: 5,
        isPositive: false
      }} data-id="element-842" data-mp="3ck3csavvscx8" />
        <StatsCard icon={<ClockIcon size={24} data-id="element-845" data-mp="32myzz1nxdtt3" />} label="Pending Approvals" value={42} trend={{
        value: 15,
        isPositive: false
      }} data-id="element-844" data-mp="32m5qhsxl0q79" />
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-846" data-mp="3vb37lsq24gyf">
        {/* Bar Chart */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-847" data-mp="42ys3v46zroj">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-848" data-mp="3llbaoruhjbqs">
            Permits Issued by Month
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-849" data-mp="3qitbfuycmknp">
            <BarChart data={permitData} data-id="element-850" data-mp="i41hagqhhi3o">
              <CartesianGrid strokeDasharray="3 3" data-id="element-851" data-mp="i301y02fq9g5" />
              <XAxis dataKey="month" data-id="element-852" data-mp="murjxm7iz6uo" />
              <YAxis data-id="element-853" data-mp="mvt88sdjxpuc" />
              <Tooltip data-id="element-854" data-mp="mwcevcxr4rt2" />
              <Bar dataKey="permits" fill="#1B5E20" data-id="element-855" data-mp="mwm8rblx3j41" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Pie Chart */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-856" data-mp="2qbptavng6whh">
          <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-857" data-mp="2ldegqd5rq7vk">
            Beneficiaries by Profession
          </h3>
          <ResponsiveContainer width="100%" height={300} data-id="element-858" data-mp="2gfmsbt4c13w4">
            <PieChart data-id="element-859" data-mp="3e2c1cmxgcgrh">
              <Pie data={professionData} cx="50%" cy="50%" labelLine={false} label={({
              name,
              percent
            }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-860" data-mp="3e2v611y3d8nk">
                {professionData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-861" data-mp="p09kb1msdz9" data-mpi={index} />)}
              </Pie>
              <Tooltip data-id="element-862" data-mp="3s0jvyo70n5zh" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-863" data-mp="86yes3cs52wo">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-864" data-mp="8786pwhdxk50">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-865" data-mp="d5rt1xzw4xxw">
            Recent Activity
          </h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-866" data-mp="i5xf8yne5s8l">
          {recentActivity.map((activity, idx) => <div key={idx} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50" data-id="element-867" data-mp="n3fm8jhulxdy" data-mpi={idx}>
              <div className="flex-1" data-id="element-868" data-mp="vwiywpko667j">
                <div className="text-sm font-medium text-gray-900" data-id="element-869" data-mp="vxkcp1t2l6sy">
                  {activity.action}
                </div>
                <div className="text-xs text-gray-600 mt-1" data-id="element-870" data-mp="10uu9j2isgkqt">
                  by {activity.user} • {activity.time}
                </div>
              </div>
              <StatusBadge status={activity.status} data-id="element-871" data-mp="1at9xwxqflfwm" />
            </div>)}
        </div>
      </div>

      {/* Pending Approvals */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-872" data-mp="l5xk2mse9yu4">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-873" data-mp="g7clerssjn7s">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-874" data-mp="uvh2xsg3xsoz">
            Pending Approvals
          </h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-875" data-mp="q47egv6aoveo">
          {pendingApprovals.map(item => <div key={item.id} className="px-6 py-4 flex items-center justify-between hover:bg-gray-50" data-id="element-876" data-mp="13vmaq3p7qt3o">
              <div className="flex-1" data-id="element-877" data-mp="ywswg923qy2g">
                <div className="text-sm font-medium text-gray-900" data-id="element-878" data-mp="1du1shg2coq0i">
                  {item.name}
                </div>
                <div className="text-xs text-gray-600 mt-1" data-id="element-879" data-mp="18uywel4clu4o">
                  {item.type} • {item.id} • {item.date}
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-880" data-mp="3fnj8b70mwx6c">
                <button className="px-3 py-1.5 bg-[#1B5E20] text-white text-sm rounded-lg hover:bg-[#2E7D32]" data-id="element-881" data-mp="3anwvuzsmrkyl">
                  Approve
                </button>
                <button className="px-3 py-1.5 border border-gray-300 text-gray-700 text-sm rounded-lg hover:bg-gray-50" data-id="element-882" data-mp="1v3e5e3fltl25">
                  Reject
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}